import { MemberStatus } from '@prisma/client';
import { useQuery } from '@tanstack/react-query';
import { ResolvedInvitation } from '@zond/api-interfaces';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { client } from '../../../../client';
import i18n from '../../../i18n/config';

// TODO: Replace with your actual API service
const fetchInvitation = async (invitationId: string): Promise<ResolvedInvitation> => {
  const response = await fetch(`/api/invitations/${invitationId}`);
  if (!response.ok) {
    throw new Error('Failed to fetch invitation');
  }
  return response.json();
};

export function useInvitation(invitationId: string | undefined) {
  const navigate = useNavigate();

  return useQuery<ResolvedInvitation>({
    queryKey: ['invitation', invitationId],
    queryFn: async () => {
      if (!invitationId) {
        toast.error(i18n.t('invitations:toast.workspaceNotFound'));
        navigate('/');
        throw new Error('Invitation ID is required');
      }

      try {
        const { data } = await client.get<ResolvedInvitation>(`/invitations/${+invitationId}`);

        if (data.status === MemberStatus.Active) {
          navigate(`/${data.workspaceId}`);
        }

        return data;
      } catch (error) {
        toast.error(i18n.t('invitations:toast.otherAccount'));
        navigate('/');
        throw error;
      }
    },
    enabled: !!invitationId,
  });
}
